{
  "user": {
    "Detayları Düzenle": "Edit Details",
    "Foto": "Photo",
    "Hesap": "Account",
    "Mevcut Şifre": "Current Password",
    "Profil": "Profile",
    "Yeni Resim Yükle": "Upload New Image",
    "Şifre Değiştirme": "Password Change",
    "Şifre Kontrol": "Password Check",
    "Bildirim İzinleri": "Notification Permissions",
    "Bu Cihaz": "This Device",
    "Bu cihazdan bildirim alıp almayacağınızı buradan yönetebilirsiniz.": "You can manage whether to receive notifications from this device here.",
    "desc_notification_manage": "You can manage whether to receive notifications from this device here.",
    "Bildirimleri Kapat": "Disable Notifications",
    "Bildirimleri Aç": "Enable Notifications",
    "Tarayıcınız bildirimleri desteklemiyor": "Your browser does not support notifications.",
    "Bildirim izni reddedildi Tarayıcı ayarlarından izin verin": "Notification permission denied. Please allow from browser settings.",
    "Kayıtlı Cihazlar": "Registered Devices",
    "Cihaz Bilgisi": "Device Info",
    "Kayıt Tarihi": "Registration Date",
    "Son Erişim": "Last Access",
    "İşlem": "Action",
    "Bilinmeyen Cihaz": "Unknown Device",
    "Kayıtlı cihaz bulunamadı": "No registered devices found.",
    "Cihaz listesi alınamadı": "Could not fetch device list.",
    "Bu cihazın bildirim aboneliğini silmek istediğinize emin misiniz": "Are you sure you want to delete this device's subscription?",
    "Cihaz silindi": "Device deleted.",
    "Cihaz silinemedi": "Could not delete device."
  }
}
